// DEVELOPMENT ENVIRONMENT VARIABLES
const APP_DEVELOPMENT_URL = process.env.NEXT_PUBLIC_APP_DEVELOPMENT_URL;
const APP_DEVELOPMENT_URL_Ecom = process.env.NEXT_PUBLIC_APP_DEVELOPMENT_URL_Ecom;
const APP_DEVELOPMENT_URL_ERP = process.env.NEXT_PUBLIC_APP_DEVELOPMENT_URL_ERP;

// Staging ENVIRONMENT VARIABLES
// const APP_DEVELOPMENT_URL = "https://devapi.ezfze.com/v1/Ecomapi";
// const APP_DEVELOPMENT_URL_Ecom = "https://devapi.ezfze.com/v1/Ecomapi";
// const APP_DEVELOPMENT_URL_ERP = "https://devapi.ezfze.com/v1/ERPapi";

export default {
  APP_DEVELOPMENT_URL,
  APP_DEVELOPMENT_URL_Ecom,
  APP_DEVELOPMENT_URL_ERP,
};
